export const PERMISSIONS = {
  ADMIN: "admin",
  RECORDSWING: "recordswing",
  MANAGEOTHERSESSIONS: "manageothersessions"
} as const;